import { CompetencyReport } from "@/components/reviews/CompetencyReport";
import { useSetBreadcrumbs } from "@/components/shared/breadcrumbs";
import { PageHeader } from "@/components/shared/page-header";

/** How a whole role performed against each competency — EPIC-071. */
export function CompetencyReportPage() {
  useSetBreadcrumbs([
    { label: "Feedback" },
    { label: "Reviews", to: "/dashboard/reviews" },
    { label: "Competency Report" },
  ]);

  return (
    <div className="space-y-6">
      <PageHeader
        title="Competency Report"
        description="How a whole role performed against each competency, by level, against the written standard."
      />
      <CompetencyReport />
    </div>
  );
}
